import React, { useCallback } from 'react';
import { AnimatedContainer } from '../AnimatedContainer/AnimatedContainer';
import { SupportedAlohaHeaderPhotoLayoutSchema } from '@apps/guest/packages/layout-engine/layouts/hooks/useWebsiteHeaderSettings';
import { PhotoSlider } from '@apps/guest/packages/layout-engine/widgets/Custom/components';
import { Photo } from '../Photo/Photo';

interface HeaderPhotoProps {
  headerPhoto?: SupportedAlohaHeaderPhotoLayoutSchema;
}

export const HeaderPhoto = ({ headerPhoto }: HeaderPhotoProps) => {
  const getHeaderPhotoComponent = useCallback(() => {
    if (!headerPhoto) {
      return null;
    }

    switch (headerPhoto.presentationLayout) {
      case 'center':
        return (
          <AnimatedContainer>
            <Photo {...headerPhoto?.photos?.[0]} />
          </AnimatedContainer>
        );
      case 'photoSlider':
        return (
          <AnimatedContainer>
            {/**
             * We are not passing aspect ratio, because the container and canvas uses different aspect ratio.
             * For aloha layout, we are using the max dimension for cropping (for rendering the canvas in 1:1 aspect ratio by ignoring the parent container dimensions).
             */}
            <PhotoSlider photos={headerPhoto?.photos?.map(photo => ({ ...photo, id: photo.id, photoUrl: photo.url })) || []} photoHeight="100vh" isMaxDimensionForCropping={true} />
          </AnimatedContainer>
        );
      default:
        return null;
    }
  }, [headerPhoto]);

  return getHeaderPhotoComponent();
};
